<style lang="less" scoped >
    .selected-item {
      border-color: #1976d2!important;
      color: #1976d2;
    }
    .content {
      display: flex;
      flex-direction: column;
      background: #fff;
      height: 400px;
      width: 300px;
    }
    .search-c {
        padding: 10px;
    }
    .content-c {
        flex: 1;
        overflow: auto;
    }
    .item-detial {
        padding: 0 10px;
        display: block;
        margin: 5px;
        padding: 3px 6px;
        border: 1px solid #dddee1;
        border-radius: 4px;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
     
    }
    .item-detial:hover {
          background: #eeeeee;
    }
   .footer {
    padding: 10px;
    text-align: right;
   }
   .selected-header {
    margin: 0 10px -20px;
   }
</style>
<template>
  <v-menu
    ref="menu"
    v-model="menu"
    content-class="menu-c"
    :close-on-content-click="false"
    :close-on-click="false"
    transition="scale-transition"
    offset-y
    top
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="my_value.unit_price"
        :label="text"
        :placeholder="placeholder"
        required
        :rules="rules"
        :disabled="disabled"
        readonly
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <div class="content">
      <div
       
        class="search-c"
      >
        <v-text-field
          v-model="my_value.unit_price"
          label="单价"
          clearable
          @blur="blurInput"
        />
      </div>
      <div
        v-show="type==='select'"
        class="content-c"
      >
        <div>
          <div
            v-for="(item,index) in stockPrices"
            :key="index"
          >
            <div>
              <RenderContain 
                :target="item"
                :selected-id="my_value.stock_price_id"
                @onSelected="selected"
              />
            </div>
          </div> 
        </div>
      </div>
      <div class="footer">
        <v-btn
          tile
          color="primary"
          text
          x-small
          @click="menu=false"
        >
          确定
        </v-btn>  
      </div>
    </div>
  </v-menu>
</template>
<script>
  import {getsafe, formattingNumber} from '@/libs/util.js'
  import expense_util from '@/libs/expense_util.js'
  const negPattern = /^-?\d*\.?\d+$/;
  const currencies_label_hash = expense_util.currencies_label_hash
  // price
  const RenderContain = {
    props: {
      target: {
        type: Object,
      },
      selectedId: {
        type: [Number, String]
      }
    },
    render(h) {
      const currency = getsafe(currencies_label_hash, `${this.target.currency}.symbol`, '')
      const effective_date = getsafe(this.target, 'effective_date', '')
      const expiry_date = getsafe(this.target, 'expiry_date', '')
      const supplier = getsafe(this.target, 'supplier', '')
      const id = getsafe(this.target, 'id', '')
      return h('div', {
        class: `item-detial ${this.selectedId === id && 'selected-item'}`,
        on: {
          click: () => {
            this.$emit('onSelected', this.target)
          }
        }
      }, [
        h('p', {
          class: 'item-detail-p ',
          style: 'margin-bottom: 0px;'
        }, ['供应商：', supplier]),
        h('p', {
          class: 'item-detail-p ',
          style: 'margin-bottom: 0px;'
        }, ['价格：', currency, formattingNumber(this.target.price, 2)]),
        h('p', {
          class: 'item-detail-p ',
          style: 'margin-bottom: 0px;'
        }, ['范围：', effective_date, '~', expiry_date])
      ])
    }
  } 
  export default {
    components: {RenderContain},
    props: {
      disabled: {
        type: Boolean,
      },
 
      value: {
        type: Object
      },
      text: {
        type: String,
        default: ''
      },
      placeholder: {
        type: String,
        default: ''
      },
      stockPrices: {
        type: Array,
        default: () => []
      }
    },
    data() {
      this.rules = [val => {
        return !['', undefined, null].includes(val) || '必填'
      }, val => {
        return negPattern.test(val + '') || '请输入有效数字'
      }]
      this.pre_stock_id = null
      return {
        menu: false,
        date: '',
        in_params: {
          search: '',
        },
        history_item_hash: {},
        getListLoading: false,
        my_value: this.value,
        type: 'select'
      }
    },
    computed: {
      list() {
        const l = getsafe(this.my_value, '_item.stock_prices', [])
        return l
      },
    },
    watch: {
      'my_value.unit_price'() {
        this.$emit('change')
      },  
      my_value(val) {
        this.$emit('input', val)
      },
      value: {
        deep: true,
        handler(val) {
          if (val.stock_id !== this.pre_stock_id) {
            this.menu = false
          }
          this.pre_stock_id = val.stock_id
          this.my_value = val
        }
      },  
     
    },  
    methods: {
      // selectDate(item, c_item, index, list, payee_company_accounts) {
      //   this.$refs.menu.save(item);
      //   this.my_value = item.id
      //   this.$emit('change', item.id, item, c_item, index, list, payee_company_accounts);
      // },
      blurInput() {
        if (this.my_value.stock_price_id) {
          (this.stockPrices || []).forEach(stock => {
            const unit_price = getsafe(this.my_value, 'unit_price')
            const stand_price = getsafe(stock, 'price')
            if (stock.id === this.my_value.stock_price_id && Number(unit_price) !== Number(stand_price)) {
              this.my_value.stock_price_id = null
            }
          });
       
        } 
      },
      selected(t) {
        if (this.my_value.stock_price_id === t.id) {
          this.my_value.stock_price_id = null
          this.my_value.unit_price = null
          return  
        }
        this.my_value.unit_price = t.price
        this.my_value.stock_price_id = t.id
      }
    }
  }
</script>
